import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { Carousel } from '@beef/smart-kit';
import { useIsDesktopDimension, useIsMobileDimension } from '@beef/ui-kit/hooks';
import { compose } from '@beef/utils';
import classNames from 'classnames/bind';
import { isEmpty } from 'lodash';
import { getNewsCardsListItems } from "../../store/blocks/news/selectors";
import { FttbBlocks } from "../constants";
import { defineBlock } from "../utils";
import { CarouselLayout } from "./components/CarouselLayout";
import { NewsCard } from "./components/News\u0421ard";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var _NewsBlock = function _NewsBlock(_ref) {
  var cards = _ref.cards,
    className = _ref.className;
  var isMobile = useIsMobileDimension();
  var isDesktop = useIsDesktopDimension();
  return /*#__PURE__*/React.createElement(CarouselLayout, {
    className: className,
    "data-t-id": "blocks-NewsBlock"
  }, /*#__PURE__*/React.createElement(Carousel, {
    className: cx('carousel'),
    paginatePadding: false,
    settings: {
      pagination: isDesktop && {
        clickable: true
      },
      simulateTouch: true,
      slidesPerGroup: !isDesktop ? 1 : 3,
      slidesPerView: !isDesktop ? 'auto' : 3,
      spaceBetween: isMobile ? 16 : 24
    },
    slideWidthAuto: !isDesktop,
    "data-t-id": "blocks-NewsBlock"
  }, cards.map(function (card) {
    return card.title && /*#__PURE__*/React.createElement(NewsCard, _extends({}, card, {
      key: card.id
    }));
  })));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    cards: getNewsCardsListItems(state),
    shouldRender: !isEmpty(getNewsCardsListItems(state))
  };
};
var connector = connect(mapStateToProps);
export var NewsBlock = compose(connector, defineBlock(FttbBlocks.NEWS), withRenderFlag)(_NewsBlock);